import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private refreshNotificationCountSource = new Subject<void>();
  refreshNotificationCount$ = this.refreshNotificationCountSource.asObservable();

  triggerNotificationCountRefresh() {
    this.refreshNotificationCountSource.next();
  }
}
